import { render, staticRenderFns } from "./SelectDayOfWeek.vue?vue&type=template&id=9934b4ec&"
import script from "./SelectDayOfWeek.vue?vue&type=script&lang=ts&"
export * from "./SelectDayOfWeek.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports